"use strict";
// STRAPI_API service
Object.defineProperty(exports, "__esModule", { value: true });
exports.WeddingStatusEnum = exports.WeddingItineraryItemIconTypeEnum = exports.RSVPQuestionFieldTypeEnum = void 0;
var RSVPQuestionFieldTypeEnum;
(function (RSVPQuestionFieldTypeEnum) {
    RSVPQuestionFieldTypeEnum["SHORT_TEXT"] = "shortText";
    RSVPQuestionFieldTypeEnum["LONG_TEXT"] = "longText";
    RSVPQuestionFieldTypeEnum["DROPDOWN"] = "dropDown";
    RSVPQuestionFieldTypeEnum["RADIO"] = "radio";
    RSVPQuestionFieldTypeEnum["CHECKBOX"] = "checkbox";
    RSVPQuestionFieldTypeEnum["DATE"] = "date";
    RSVPQuestionFieldTypeEnum["TIME"] = "time";
    RSVPQuestionFieldTypeEnum["DATETIME"] = "dateTime";
})(RSVPQuestionFieldTypeEnum = exports.RSVPQuestionFieldTypeEnum || (exports.RSVPQuestionFieldTypeEnum = {}));
var WeddingItineraryItemIconTypeEnum;
(function (WeddingItineraryItemIconTypeEnum) {
    WeddingItineraryItemIconTypeEnum["RING"] = "ring";
    WeddingItineraryItemIconTypeEnum["PLANE"] = "plane";
    WeddingItineraryItemIconTypeEnum["CAR"] = "car";
    WeddingItineraryItemIconTypeEnum["WINE_GLASSES"] = "wineGlasses";
    WeddingItineraryItemIconTypeEnum["FOUNTAIN"] = "fountain";
    WeddingItineraryItemIconTypeEnum["CLOCHE"] = "cloche";
    WeddingItineraryItemIconTypeEnum["CHURCH"] = "church";
    WeddingItineraryItemIconTypeEnum["STAR_CONFETTI"] = "starConfetti";
    WeddingItineraryItemIconTypeEnum["BEACH_PARASOL"] = "beachParasol";
    WeddingItineraryItemIconTypeEnum["NO_ICON"] = "noIcon";
})(WeddingItineraryItemIconTypeEnum = exports.WeddingItineraryItemIconTypeEnum || (exports.WeddingItineraryItemIconTypeEnum = {}));
var WeddingStatusEnum;
(function (WeddingStatusEnum) {
    WeddingStatusEnum["CREATED"] = "created";
    WeddingStatusEnum["SUBMITTED_FOR_REVIEW"] = "submittedForReview";
    WeddingStatusEnum["LIVE"] = "live";
})(WeddingStatusEnum = exports.WeddingStatusEnum || (exports.WeddingStatusEnum = {}));
//# sourceMappingURL=weddings.js.map